import TYPES from '@/modules/shared/types';

// Domain
import { CustomerBankAccountRepository } from '../../domain/repositories/customer-bank-account-repository';
import { CustomerBankAccountDto } from '../../domain/dtos/customer-bank-account-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CustomerBankAccountHttpRepository implements CustomerBankAccountRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/user/customer-bank-account/`;

  update(payload: CustomerBankAccountDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'PATCH', payload)
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json().then(
              ({ message }) => {
                reject(new Error(message));
              },
            );
          }
        })
        .catch(reject);
    });
  }
}
